import { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

type WbTableToolbarProps = {
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    flex: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      minHeight: 36,
    },
    filler: {
      marginLeft: 'auto',
    },
  }),
  { name: 'WbTableToolbar' },
);

export const WbTableToolbarFiller: React.FC = () => {
  const classes = useStyles();
  return <div className={classes.filler} />;
};

export function WbTableToolbar({
  className,
  style,
  children,
}: WbTableToolbarProps) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.flex, className)} style={style}>
      {children}
    </div>
  );
}
